import { Button } from '@shared/components/shadcn';
import Link from 'next/link';
import type { ComponentProps } from 'react';

type HomeWinnersStoriesCtaProps = Omit<ComponentProps<typeof Link>, 'children'> & {
  label: string;
  'data-testid'?: string;
  className?: string;
};

function HomeWinnersStoriesCta({ label, className, 'data-testid': dataTestId, ...props }: HomeWinnersStoriesCtaProps) {
  return (
    <Button asChild variant="primary" size="m" className={className} data-testid={dataTestId} data-track-name="See more winners">
      <Link {...props}>{label}</Link>
    </Button>
  );
}

export { HomeWinnersStoriesCta };
